import { PayloadAction } from '@reduxjs/toolkit';
import { SingleItemData } from './types';
import { initialState } from './index';

export const reducers = {
  getConfiguratorData(state) {
    state.isLoading = true;
  },
  getConfiguratorDataSuccess(state, action: PayloadAction<SingleItemData>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
    state.isApiComplete = true;
  },
  getConfiguratorDataFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
    state.isApiComplete = true;
  },
  setDisplaySafetyFactor(state, action: any) {
    state.displaySafetyFactor = action.payload;
  },
  setMountingApply(state, action: any) {
    state.mountingApply = action.payload;
  },
};
